import api from "@services/apiList";
import instance from "@services/services";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import {
  GoogleOAuthConnectResponse,
  GoogleOAuthStatusResponse,
  CreatePatientQuestionnairePayload,
  PatientQuestionnaireItem,
  PatientQuestionnaireListResponse,
  PatientQuestionnaireSearchParams,
} from "./types";

const { SettingsApi } = api;

export const getGoogleOAuthStatus = async (): Promise<
  ResponseType<GoogleOAuthStatusResponse>
> => {
  const result = await instance.get(SettingsApi.googleOAuthStatus);
  return result.data;
};

export const getGoogleOAuthConnectUrl = async (): Promise<
  ResponseType<GoogleOAuthConnectResponse>
> => {
  const result = await instance.get(SettingsApi.googleOAuthConnect);
  return result.data;
};

export const disconnectGoogleOAuth = async (): Promise<ResponseType<null>> => {
  const result = await instance.post(SettingsApi.googleOAuthDisconnect);
  return result.data;
};

export const getPatientQuestionnaires = async (
  params: PatientQuestionnaireSearchParams,
): Promise<ResponseType<PatientQuestionnaireListResponse>> => {
  const result = await instance.get(SettingsApi.patientQuestionnaire, {
    params,
  });
  return result.data;
};

export const createPatientQuestionnaire = async (
  payload: CreatePatientQuestionnairePayload,
): Promise<ResponseType<PatientQuestionnaireItem>> => {
  const result = await instance.post(SettingsApi.patientQuestionnaire, payload);
  return result.data;
};
